import { render, staticRenderFns } from "./DtMoralQuantitation.vue?vue&type=template&id=74b78636&"
import script from "./DtMoralQuantitation.vue?vue&type=script&lang=js&"
export * from "./DtMoralQuantitation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports